import api from "./httpService";

export const addMemberTypeService = async (payload: { name: string }) => {
    const response = await api.post("/memberType", payload);
    return response.data;
};

export const getMemberTypeService = async () => {
    const response = await api.get("/memberType");
    return response.data;
};

export const updateMemberTypeService = async (id: string, payload: { name: string }) => {
    const response = await api.put(`/memberType/${id}`, payload);
    return response.data;
};

export const deleteMemberTypeService = async (id: string) => {
    const response = await api.delete(`/memberType/${id}`);
    return response.data;
};
